import React, { useId } from 'react';
import { LayoutGridItem } from '@cko/primitives';

import { HomepageViewId } from '../../../../config/dashboard/views/home';
import { ContentAreas } from '../../../types/contentAreas';
import { LayoutGridItemWithDivider } from './StackedViewWithDividersLayout.styles';

type StackedViewWithDividersLayoutProps = {
  contentAreas: ContentAreas;
};

// WARNING: Do not use this layout in its current state. Only the new homepage should do.
export const StackedViewWithDividersLayout = ({
  contentAreas,
}: StackedViewWithDividersLayoutProps) => {
  const { main } = contentAreas;
  const layoutId = useId();

  if (!main || !Array.isArray(main)) {
    throw new Error('StackedViewWithDividersLayout requires an array of content areas');
  }

  // TODO: Remove this logic to be view-agnostic after:
  // 1) Centralised headings have been launched: https://checkout.atlassian.net/browse/DASH-5206
  // 2) Homepage Announcement view has been removed: https://checkout.atlassian.net/browse/DASH-5190
  // "Key views" are those that contain the key content of the homepage, e.g. Balances, Payments, Issuing.
  const keySectionsViewIds = [...main]
    .map((contentInstance) => contentInstance.props.contentArea.view_id)
    .filter((viewId) => viewId !== HomepageViewId.HEADER && viewId !== HomepageViewId.ANNOUNCEMENT);

  return (
    <>
      {main.map((contentArea, index) => {
        const isHeading = contentArea.props.contentArea.view_id === HomepageViewId.HEADER;
        const isAnnouncement =
          contentArea.props.contentArea.view_id === HomepageViewId.ANNOUNCEMENT;
        const isLastKeyView =
          keySectionsViewIds.indexOf(contentArea.props.contentArea.view_id) ===
          keySectionsViewIds.length - 1;

        if (isHeading || isAnnouncement || isLastKeyView) {
          return (
            <LayoutGridItem span={24} key={`${layoutId}-row-${index}`}>
              {contentArea}
            </LayoutGridItem>
          );
        }

        return (
          <LayoutGridItemWithDivider span={24} key={`${layoutId}-row-${index}`}>
            {contentArea}
          </LayoutGridItemWithDivider>
        );
      })}
    </>
  );
};
